import {Button, Typography} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import {styled} from '@mui/material/styles';
import {CSSProperties} from 'react';

import ArrowLeftIcon from 'components/icons/arrowLeft.svg';
import CloseIcon from 'components/icons/cross.svg';

import {DECISIONS_DIALOG_RESET_PORTAL_ID} from 'modules/decisionsNext/components/DecisionsDialog/DecisionsDialogResetPortal';

const SCloseButton = styled(Button)(({theme}) => ({
  color: theme.palette.text.primary,
}));

export type DecisionsDialogTitleCloseType = 'icon' | 'text' | 'none';

const SResetContainer = styled('div')({
  display: 'flex',
  marginRight: 8,
});

const SRoot = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  padding: theme.spacing(4),
  paddingLeft: theme.spacing(11),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 4, 2, 4),
  },
}));

const SCollapse = styled(Collapse)(({theme}) => ({
  [theme.breakpoints.up('sm')]: {
    position: 'absolute',
    left: theme.spacing(4),
  },
}));

const STypography = styled(Typography)(() => ({
  flex: 1,
}));

export const DecisionsDialogTitle = ({
  title,
  onBack,
  onClose,
  titleAlign,
  closeType = 'none',
}: {
  title: string;
  reservedSpaceForBack?: boolean;
  onBack?: () => void;
  onClose?: () => void;
  titleAlign?: CSSProperties['textAlign'];
  closeType?: DecisionsDialogTitleCloseType;
}) => {
  return (
    <SRoot>
      <SCollapse in={!!onBack} orientation='horizontal'>
        <IconButton size='small' onClick={onBack}>
          <ArrowLeftIcon width={20} height={20} />
        </IconButton>
      </SCollapse>

      <STypography textAlign={titleAlign} variant='h4' data-testid='decisions-dialog-title'>
        {title}
      </STypography>

      <SResetContainer id={DECISIONS_DIALOG_RESET_PORTAL_ID} />

      {closeType === 'icon' && (
        <IconButton size='small' onClick={onClose}>
          <CloseIcon width={20} height={20} />
        </IconButton>
      )}

      {closeType === 'text' && (
        <SCloseButton onClick={onClose} variant='text' size='small'>
          Cancel
        </SCloseButton>
      )}
    </SRoot>
  );
};
